module.exports = __webpack_public_path__ + "img/logo_gov_ma2.024cb6b7.jpeg";